<template>
  <div>
    <v-autocomplete
      v-model="userIds"
      :items="items"
      :dense='dense'
      chips
      small-chips
      item-text="nameDeptStr"
      :item-value="mid ? 'mdUserId' : 'id'"
      :multiple='multiple'
      :label="label"
      @change="change"
      @input="idChange"
      v-bind="$attrs"
      deletable-chips
      :loading="loading"
    >
    <template v-slot:selection="{ item, index }">
        <span v-if="index === 0">{{ item.name }}</span>
        <!-- <v-chip small v-if="index === 0" color='primary'>
          <span>{{ item.name }}</span>
        </v-chip> -->
        <span
          v-if="index === 1"
          class="grey--text text-caption"
        >
          (+{{ userIds.length - 1 }} 其他人)
        </span>
      </template>
    </v-autocomplete>
 </div>
</template>

<script>
  import { getByMid } from '@/api/system/user.js'

  export default {
    name: 'MarerialUserSelect',
    components: {
    },
    props: {
      value: {
        type: [Number, Array, String]
      },
      menu: {
        type: Number,
        required: false
      },
      label: {
        type: String,
        default: '用户选择'
      },
      mid: { // 是否返回加密后的userid md_user_id
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: true
      },
      dense: {
        type: Boolean,
        default: true
      },
      otherUsers: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        items: [],
        userIds: this.value,
        loading: false,
        form: {
          mid: this.menu,
          name: ''
        }
      }
    },
    methods: {
      idChange (val) {
        this.$emit('input', val)
      },
      change (val) {
        this.$emit('on-change', val)
      },
      loadData () {
        this.loading = true
        getByMid(this.form).then(res => {
          if (res.status === 200) {
            this.items = res.data
            this.otherUsers.forEach(user => {
              this.items.push(user)
            })
          }
          this.loading = false
        })
      }
    },
    watch: {
      value (ne) {
        this.userIds = ne
      }
    },
    created() {
      this.loadData()
    }
  }
</script>

<style >
  .v-input__append-outer{
    margin-top: -3px !important;
  }
  .chip-dom {
    border: 1px solid #e0e0e0;
    height: 80px;
    padding: 5px;
    margin: 5px 7px 0 7px;
    border-radius: 3px;
    overflow: auto;
  }
</style>
